<template>
  <el-dialog
    title="分类信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      size="small"
    >
      <el-form-item
        prop="company_name"
        label="公司名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.company_name"
                placeholder="请选择公司名称"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="quantity"
        label="数量"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.quantity"></el-input>
      </el-form-item>
      <el-form-item
        prop="face_value"
        label="面值"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.face_value"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {

        formEdit: true,
      loading: false,
      dialogVisible: false,
      typeOptions: [],
      form: {
        company_name: "",
        quantity: "",
        face_value: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      var formData2 = new FormData() // 声明一个FormData对象
      oneclassService.getCompanyid(formData2).then(data => {
        this.typeOptions=data;
      });
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};

          this.form = form;
       // });
          this.formEdit = true;
      } else {
          this.formEdit = true;
          this.fileList=[];
        this.form = {};
      }
    },


    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            var formData = new FormData() // 声明一个FormData对象
           // formData.append('file', this.files, this.fileName);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名

            formData.append('company_name',this.form.company_name)
            formData.append('quantity',this.form.quantity)
            formData.append('face_value',this.form.face_value)

                        this.loading = true;
            oneclassService
                            .saveYearvoucher(formData)
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

